import {IAction} from '../interface';
import {InferActionsTypes} from '../helpers';
import {
  ILibraryLoadedPayload,
  IPatientAssignment,
  IPatientCareTeamMember,
  IPatientMedication,
  IProgramAllowedManualEventsLoadedPayload,
  IProgramCareTeamLoadedPayload,
  IProgramDetailLoadedPayload,
  IProgramLibraryLoadedPayload,
  IProgramModulesLoadedPayload,
  IProgramNextLoadedPayload,
  IRunLoadedPayload,
  IStepContentLoadedPayload
} from './interfaces';

export const ASSIGNMENTS_LOADED = 'ASSIGNMENTS_LOADED';
export const assignmentsLoadedAction = (assignments: IPatientAssignment[]): IAction<IPatientAssignment[]> => ({
  type: ASSIGNMENTS_LOADED,
  payload: assignments
});

export const RUN_LOADED = 'RUN_LOADED';
export const runLoadedAction = (payload: IRunLoadedPayload): IAction<IRunLoadedPayload> => ({
  type: RUN_LOADED,
  payload
});

export const LIBRARY_LOADED = 'LIBRARY_LOADED';
export const libraryLoadedAction = (payload: ILibraryLoadedPayload): IAction<ILibraryLoadedPayload> => ({
  type: LIBRARY_LOADED,
  payload
});

export const MEDICATIONS_LOADED = 'MEDICATIONS_LOADED';
export const medicationsLoadedAction = (medications: IPatientMedication[]): IAction<IPatientMedication[]> => ({
  type: MEDICATIONS_LOADED,
  payload: medications
});

export const CARE_TEAM_LOADED = 'CARE_TEAM_LOADED';
export const careTeamLoadedAction = (providers: IPatientCareTeamMember[]): IAction<IPatientCareTeamMember[]> => ({
  type: CARE_TEAM_LOADED,
  payload: providers
});

export const ASSISTANT_SESSION_LOADED = 'ASSISTANT_SESSION_LOADED';
export const assistantSessionLoadedAction = (active: boolean): IAction<boolean> => ({
  type: ASSISTANT_SESSION_LOADED,
  payload: active
});

export const INTERVENTIONS_CLEARED = 'INTERVENTIONS_CLEARED';
export const interventionsClearedAction = (): IAction<null> => ({
  type: INTERVENTIONS_CLEARED,
  payload: null
});

export const PROGRAM_DETAIL_LOADED = 'PROGRAM_DETAIL_LOADED';
export const programDetailLoadedAction = (payload: IProgramDetailLoadedPayload): IAction<IProgramDetailLoadedPayload> => ({
  type: PROGRAM_DETAIL_LOADED,
  payload
});

export const PROGRAM_NEXT_LOADED = 'PROGRAM_NEXT_LOADED';
export const programNextLoadedAction = (payload: IProgramNextLoadedPayload): IAction<IProgramNextLoadedPayload> => ({
  type: PROGRAM_NEXT_LOADED,
  payload
});

export const PROGRAM_MODULES_LOADED = 'PROGRAM_MODULES_LOADED';
export const programModulesLoadedAction = (payload: IProgramModulesLoadedPayload): IAction<IProgramModulesLoadedPayload> => ({
  type: PROGRAM_MODULES_LOADED,
  payload
});

export const PROGRAM_LIBRARY_LOADED = 'PROGRAM_LIBRARY_LOADED';
export const programLibraryLoadedAction = (payload: IProgramLibraryLoadedPayload): IAction<IProgramLibraryLoadedPayload> => ({
  type: PROGRAM_LIBRARY_LOADED,
  payload
});

export const PROGRAM_CARE_TEAM_LOADED = 'PROGRAM_CARE_TEAM_LOADED';
export const programCareTeamLoadedAction = (payload: IProgramCareTeamLoadedPayload): IAction<IProgramCareTeamLoadedPayload> => ({
  type: PROGRAM_CARE_TEAM_LOADED,
  payload
});

export const PROGRAM_ALLOWED_MANUAL_EVENTS_LOADED = 'PROGRAM_ALLOWED_MANUAL_EVENTS_LOADED';
export const programAllowedManualEventsLoadedAction = (
  payload: IProgramAllowedManualEventsLoadedPayload
): IAction<IProgramAllowedManualEventsLoadedPayload> => ({
  type: PROGRAM_ALLOWED_MANUAL_EVENTS_LOADED,
  payload
});

export const STEP_CONTENT_LOADED = 'STEP_CONTENT_LOADED';
export const stepContentLoadedAction = (payload: IStepContentLoadedPayload): IAction<IStepContentLoadedPayload> => ({
  type: STEP_CONTENT_LOADED,
  payload
});

const interventionActions = {
  assignmentsLoadedAction,
  runLoadedAction,
  libraryLoadedAction,
  medicationsLoadedAction,
  careTeamLoadedAction,
  assistantSessionLoadedAction,
  interventionsClearedAction,
  programDetailLoadedAction,
  programNextLoadedAction,
  programModulesLoadedAction,
  programLibraryLoadedAction,
  programCareTeamLoadedAction,
  programAllowedManualEventsLoadedAction,
  stepContentLoadedAction
};

export type InterventionActionsType = InferActionsTypes<typeof interventionActions>
